import axios, { AxiosResponse } from "axios";

export interface ApiResponse<T = any> {
  statusCode: number;
  data?: T;
  message?: string;
}

export interface AuthPayload {
  username: string;
  password: string;
}

export interface MovieListEntry {
  id: string;
  createdBy: string;
  movieList: string[];
}

export interface MovieListPayload {
  id?: string;
  createdBy?: string;
  movieList: string[];
}

export default class ApiService {

  static API_URL = process.env.REACT_APP_API_URL;

  static saveToken(token: string) {
    localStorage.setItem("token", token);
  }

  static getToken(): string | null {
    return localStorage.getItem("token");
  }

  static isAuthenticated(): boolean {
    return !!this.getToken();
  }

  static logout(): void {
    localStorage.removeItem("token");
  }

  static getHeader(): { Authorization: string; "Content-Type": string } {
    const token = this.getToken();
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
  }

  // Register USER
  static async registerUser(body: AuthPayload): Promise<ApiResponse<string>> {
    const resp: AxiosResponse<ApiResponse<string>> = await axios.post(
      `${this.API_URL}/auth/register`,
      body
    );
    return resp.data;
  }

  // Login USER
  static async loginUser(body: AuthPayload): Promise<ApiResponse<string>> {
    const resp: AxiosResponse<ApiResponse<string>> = await axios.post(
      `${this.API_URL}/auth/login`,
      body
    );
    return resp.data;
  }

  // Movies API
  static async getAllMovieLists(): Promise<ApiResponse<MovieListEntry[]>> {
    const resp: AxiosResponse<ApiResponse<MovieListEntry[]>> = await axios.get(
      `${this.API_URL}/movies/all-movies`
    );
    return resp.data;
  }

  static async createMovieList(
    body: MovieListPayload
  ): Promise<ApiResponse> {
    const resp: AxiosResponse<ApiResponse> = await axios.post(
      `${this.API_URL}/movies/my-movies`,
      body,
      { headers: this.getHeader() }
    );
    return resp.data;
  }

  static async getMyMovieList(): Promise<ApiResponse<MovieListEntry[]>> {
    const resp: AxiosResponse<ApiResponse<MovieListEntry[]>> = await axios.get(
      `${this.API_URL}/movies/my-movies`,
      { headers: this.getHeader() }
    );
    return resp.data;
  }

  static async updateMovieList(
    body: MovieListPayload
  ): Promise<ApiResponse> {
    const resp: AxiosResponse<ApiResponse> = await axios.put(
      `${this.API_URL}/movies/my-movies`,
      body,
      { headers: this.getHeader() }
    );
    return resp.data;
  }

  static async deleteMovieList(
    body: MovieListPayload
  ): Promise<ApiResponse> {
    const resp: AxiosResponse<ApiResponse> = await axios.delete(
      `${this.API_URL}/movies/my-movies`,
      { headers: this.getHeader(), data: body }
    );
    return resp.data;
  }
}
